import {
  responsive,
  spacing,
  ThemeUICSSObject,
  getSpacingLayouts,
} from '@apia/theme';

export const panel: ThemeUICSSObject = {
  pb: spacing(6),

  '&:last-child': {
    pb: 0,
  },
  '.panel__container': {
    background: 'palette.background.paper',
    border: '1px solid',
    borderColor: 'palette.gray.800',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 'panel',
    boxShadow: 'panel',
  },

  '.panel__icon': {
    height: '24px',
    width: '24px',
    borderRadius: '100%',
    transform: 'scale(1.25)',
    marginRight: '6px',
  },

  '.panel__header': {
    alignItems: 'center',
    cursor: 'grab',
    display: 'flex',
    flexWrap: 'nowrap',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    maxWidth: '100%',
    overflow: 'visible',
    backgroundColor: 'palette.secondary.light',
    borderBottomRightRadius: '0px !important',
    borderBottomLeftRadius: '0px !important',
    pl: 4,
    py: 4,

    borderRadius: 'panel',

    '.panel__header__left': {
      alignItems: 'center',
      display: 'flex',
      gap: 2,
      overflow: 'visible',

      svg: {
        color: 'palette.error.dark',
      },
    },

    '& > *': {
      flexShrink: 0,
    },

    '.panel__header__buttons': {
      alignSelf: 'end',
      display: 'flex',
      flexGrow: 1,
      fontWeight: 'normal',
      gap: 2,
      justifyContent: 'end',
      right: 0,
      background: 'transparent',
      pr: 3,
      opacity: responsive({ 0: 1, 3: 0 }),
      alignItems: 'center',
      pl: 3,
      height: '24px',
      button: {
        width: '30px',
        height: '30px',
      },
    },
  },

  '.panel__content': {
    ...getSpacingLayouts(),
  },

  '.panel__container:hover, .panel__container:focus, .panel__container:focus-within, .panel__container.isLoading':
    {
      '.panel__header__buttons, .lastUpdate__wrapper': {
        opacity: responsive({ 0: 1 }),
      },
    },

  '.panel__footer': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: spacing(3),
    background: 'palette.secondary.light',
    px: 4,
    py: 3,
    color: 'palette.text.primary',
    borderRadius: 'panel',
    borderTopRightRadius: '0px',
    borderTopLeftRadius: '0px',
    overflow: 'hidden',
    alignItems: 'center',
  },

  '.panel__iconButton, .lastUpdate__wrapper': {
    transition: 'opacity 300ms',
  },

  '.lastUpdate__wrapper': {
    fontSize: 14,
    opacity: 0,
    flexShrink: 0,
  },

  '.panel__footer__text': {
    overflow: 'hidden',
    flexShrink: 1,
  },

  'span.panel__title': {
    flexShrink: '1 !important',
  },
};
